var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-menu absolute z-dropdown select-none",class:_vm.menuClasses,staticStyle:{"display":"block"},style:(_vm.verticalStyle)},[_c('div',{staticClass:"z-dropdown overflow-hidden bg-white border border-50 shadow rounded-lg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }